import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { LoadingButton } from '@/components/atoms/loading-button/loading-button';
import { DialogActions as DialogActionsInterface } from '@/components/molecules/dialog';
import { ImageDropzone } from '@/components/organisms/image-dropzone';
import { useUpdateOrganizationLogo } from '@/features/settings/hooks/mutation/use-update-organization-logo';

export const AddOrganizationLogoDialog = ({ onCancel, open }: DialogActionsInterface) => {
  const { t } = useTranslation(['settings', 'common']);

  const { mutate, isPending } = useUpdateOrganizationLogo();

  const [image, setImage] = useState<{ file: File | null; blob: string | null }>({
    file: null,
    blob: null,
  });

  const handleDrop = (newFile: File[]): void => {
    setImage({ file: newFile[0], blob: URL.createObjectURL(newFile[0]) });
  };

  useEffect(() => {
    setImage({ file: null, blob: null });
  }, [open]);

  return (
    <Dialog
      onClose={() => {
        onCancel?.();
        setImage({ file: null, blob: null });
      }}
      open={open}
      PaperProps={{
        sx: {
          width: '100%',
        },
      }}>
      <DialogTitle>{t('settings:logo.addLogoDialogTitle')}</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: 'grid',
            gap: 2,
            gridTemplateColumns: '1fr',
            '& img': {
              borderRadius: 1,
              maxWidth: '100%',
            },
          }}>
          <ImageDropzone
            onDrop={handleDrop}
            sx={{ height: '100%' }}
            multiple={false}
            accept={{
              'image/jpeg': ['.jpeg'],
              'image/png': ['.png'],
            }}
          />
          {image && (
            <Box
              key="img"
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              <Box
                sx={{
                  borderRadius: 1,

                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                  width: '100%',
                  height: '100%',
                }}>
                <img alt="" src={image.blob || ''} style={{ maxWidth: '100%' }} />
              </Box>
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onCancel} variant="text">
          {t('common:button.cancel')}
        </Button>
        <LoadingButton
          disabled={!image}
          color="primary"
          loading={isPending}
          onClick={() => mutate(image.file as File)}
          variant="contained">
          {t('settings:logo.addLogo')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
